'use client';

import { useTradeContext } from '../../../../components/ui/TradePageClient/TradePageClient';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { LotteryTradeMyGoods, TradeDesiredGoods } from '../../types';
import styles from './TradeSelectedPrizeList.module.scss';

export type TradeSelectedPrizeListProps = {
  tradeGoodsList: LotteryTradeMyGoods | TradeDesiredGoods;
  /** select-desired-prizesページで必要数の表示を有効にする */
  showInsufficientCount?: boolean;
};

const TradeSelectedPrizeList = ({ tradeGoodsList, showInsufficientCount = false }: TradeSelectedPrizeListProps) => {
  const { selectedItems } = useTradeContext();

  const selectedItemsByLabel = () => {
    const result: Array<{
      labelName: string;
      stagingKey: string;
      stagingName: string;
      items: Array<{
        name: string;
        count: number;
      }>;
    }> = [];

    selectedItems.forEach((count, goodId) => {
      if (count > 0) {
        // tradeGoodsListから該当するアイテムを検索
        for (const label of tradeGoodsList.labels) {
          const foundGood = label.goods?.find((good) => good.id.toString() === goodId);
          if (foundGood) {
            // 既存のラベルグループを検索
            let labelGroup = result.find((group) => group.stagingKey === label.stagingKey);
            if (!labelGroup) {
              labelGroup = {
                labelName: label.name,
                stagingKey: label.stagingKey,
                stagingName: label.stagingName,
                items: [],
              };
              result.push(labelGroup);
            }

            // アイテムを追加
            labelGroup.items.push({
              name: foundGood.name,
              count,
            });
            break;
          }
        }
      }
    });

    return result;
  };

  const selectedGroups = selectedItemsByLabel();

  // 選択された総数を計算
  const totalSelectedCount = selectedGroups.reduce((total, group) => {
    return total + group.items.reduce((groupTotal, item) => groupTotal + item.count, 0);
  }, 0);

  // 選択数が0個の場合は非表示
  if (totalSelectedCount === 0) {
    return null;
  }

  return (
    <div className={`${styles.selectedPrizeContainer}`}>
      <div className={styles.prizeSection}>
        {selectedGroups.map((group) => {
          // tradeGoodsListから該当するラベルの情報を取得
          const labelInfo = tradeGoodsList.labels.find((label) => label.stagingKey === group.stagingKey);

          // showInsufficientCountがtrueの場合はtradeableInCount、それ以外はtradeRequiredCountを使用
          let requiredCount = 0;
          if (labelInfo) {
            if (showInsufficientCount && 'tradeableInCount' in labelInfo) {
              requiredCount = (labelInfo as { tradeableInCount: number }).tradeableInCount;
            } else if ('tradeRequiredCount' in labelInfo) {
              requiredCount = labelInfo.tradeRequiredCount;
            }
          }

          // グループ内の合計個数を計算
          const groupTotalCount = group.items.reduce((sum, item) => sum + item.count, 0);

          return (
            <div key={group.stagingKey} className={styles.prizeItem}>
              <div className={styles.prizeDetails}>
                <div className={styles.prizeStagingNameWrapper}>
                  <p className={styles.prizeStagingName}>{group.stagingName}</p>
                  <p className={styles.labelName}>{group.labelName}</p>
                </div>
                <div className={styles.selectedCountWrapper}>
                  <p className={styles.selectedCount}>
                    <span className={utilsStyles.textXLarge}>{groupTotalCount}</span>
                    {showInsufficientCount && <span className={utilsStyles.textXLarge}> / {requiredCount}</span>} 個
                    選択済み
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TradeSelectedPrizeList;
